import { lazy } from 'react';

const Documents = lazy(() => import('./ProcessorDocumentsPage'));

const ProcessorDocumentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/documents',
      element: <Documents />,
    },
  ],
};

export default ProcessorDocumentsConfig;
